import { render, staticRenderFns } from "./dealerOfOneself.vue?vue&type=template&id=2fe44c9b&scoped=true&"
import script from "./dealerOfOneself.vue?vue&type=script&lang=js&"
export * from "./dealerOfOneself.vue?vue&type=script&lang=js&"
import style0 from "./dealerOfOneself.vue?vue&type=style&index=0&id=2fe44c9b&prod&lang=scss&scoped=true&"
import style1 from "./dealerOfOneself.vue?vue&type=style&index=1&id=2fe44c9b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe44c9b",
  null
  
)

export default component.exports